<script setup>
// Dialogue de confirmation global (piloté par useConfirm). Monté une fois
// dans App.vue. Remplace les window.confirm() natifs par une vraie modale.
import { useI18n } from 'vue-i18n';
import { confirmState, acceptConfirm, cancelConfirm } from '@/composables/useConfirm';
import BaseModal from '@/components/ui/BaseModal.vue';
import BaseButton from '@/components/ui/BaseButton.vue';

const { t } = useI18n();
</script>

<template>
  <BaseModal
    :open="confirmState.open"
    :title="confirmState.title || t('common.confirmTitle')"
    size="sm"
    @close="cancelConfirm"
  >
    <p class="text-sm text-gray-600 whitespace-pre-line">
      {{ confirmState.message }}
    </p>
    <template #footer>
      <BaseButton
        variant="secondary"
        @click="cancelConfirm"
      >
        {{ confirmState.cancelLabel || t('common.cancel') }}
      </BaseButton>
      <BaseButton
        :variant="confirmState.variant === 'danger' ? 'danger' : 'primary'"
        @click="acceptConfirm"
      >
        {{ confirmState.confirmLabel || t('common.confirm') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>
